import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import SearchList from './components/SearchList.js';
import {config} from './config.js';
import Print from './components/Print.js';


class App extends Component {
	constructor(props) {
		super(props);
		this.state  = {
		}
	}

render() {
    return (
      <Router className="App" basename={config.basePath}>
      	<Switch>
      	    <Route path="/" exact component={SearchList}  />
      	    <Route path="/home" component={SearchList}  />
      	    <Route path="/search/:id" render={(props) => <SearchList {...props}  />} />
      		<Route path="/print" component={Print}  />
      	</Switch>
      </Router>
    )
  }

}

export default App;



